import * as actionTypes from "constants/ActionTypes";

const integratorCompanies = (
  state = {
    isLoaded: false,
    total: 0,
    data: [],
    integratorId: null,
    page: 1,
    limit: 25,
  },
  action
) => {
  switch (action.type) {
    case actionTypes.GET_INTEGRATOR_COMPANIES.REQUEST:
      return {
        ...state,
        page: action.page,
        limit: action.limit,
        isLoaded: false,
      };
    case actionTypes.GET_INTEGRATOR_COMPANIES.SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoaded: true,
        integratorId: action.id,
      };
    }
    case actionTypes.GET_INTEGRATOR_COMPANIES.FAILURE:
      return {
        ...state,
        ...action.data,
        isLoaded: true,
        integratorId: null,
      };
    default:
      return state;
  }
};

export default integratorCompanies;



// WEBPACK FOOTER //
// ./app/reducers/integrators/companies.js